module.exports = __webpack_public_path__ + "img/9788952778499.9ca0cbbc.jpg";